import { AxiosResponse } from 'axios'
import { client } from "../../shared/services/client";
import AgencyGroupModel from '../model/AgencyGroupModel'
import FeatureDropDown from '../model/DropdownModel/FeatureDropDown'
import FeatureElementDropdown from '../model/DropdownModel/FeatureElementDropdown'
import * as tableConstant from '../../shared/util/tableConstant';
import { async } from 'q';
import AgencyMembershipModel from '../model/AgencyMembershipModel';

const securityBaseKey = "security"

export default class AgencyGroupSetupAPI {
    getAgencyGroup = async (): Promise<AgencyGroupModel[]> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<AgencyGroupModel[]> = await client.get<AgencyGroupModel[]>("api/agencies/GetAllAgencyGroups");
        return res.data;
    };

    saveAgencyGroup = async (agencyGroup: AgencyGroupModel): Promise<any> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<any> = (await client.post("api/AgenciesGroup/CreateAgencyGroup", agencyGroup));
        return res.data
    }

    updateAgencyGroup = async (agencyGroup: AgencyGroupModel): Promise<any> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<any> = (await client.post("api/AgenciesGroup/UpdateAgencyGroup", agencyGroup));
        return res.data
    }

    deleteAgencyGroup = async (model: AgencyGroupModel): Promise<any> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<any> = (await client.post("api/AgenciesGroup/DeleteAgencyGroup", model));
        return res.data
    }

    saveMembership = async (model: AgencyMembershipModel): Promise<any> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<any> = (await client.post("api/AgenciesGroup/CreateAgencyMembership", model));
        return res.data
    }

    deleteMembership = async (model: AgencyMembershipModel): Promise<any> => {
        client.setBaseURLForService("admin")
        const res: AxiosResponse<any> = (await client.post("api/AgenciesGroup/DeleteAgencyMembership", model));
        return res.data
    }
}
